
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/a51c03b2382e35c3e6bd6650ef5c1522/dbc4baadda575218bf3f908f312356a6.png" 
              alt="REDSAIL Logo" 
              className="h-10 mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 mb-4">
              Official Malta distributor of REDSAIL laser cutting and engraving machines.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/35699446552"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/applications" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Applications
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-bold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/support" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Support Center
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <span>47, Triq il Gladjoli, Madliena, Malta SWQ2023</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line flex-shrink-0"></i>
                <a href="tel:+35699446552" className="hover:text-emerald-400 transition-colors">
                  +356 9944 6552
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line flex-shrink-0"></i>
                <a href="mailto:grtrophy@gmail.com" className="hover:text-emerald-400 transition-colors">
                  grtrophy@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-building-line flex-shrink-0"></i>
                <span>VAT: MT 29045621</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} MADLIENA Landmark Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
